<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";

const props = defineProps<{
  metadata: Area;
  title: string;
  subTitle?: string;
  body?: string;
}>();

const amountOfSiblings = inject<number>("amountOfSiblings");
const computedClass = computed(() => {
  if (amountOfSiblings === 1) {
    return "col-start-7 col-span-7 lg:mx-12";
  } else {
    let result = "col-span-4";
    if (amountOfSiblings === 2 && props.metadata["@index"] === 0) {
      result += " col-start-5";
    }
    return result;
  }
});
</script>

<template>
  <div
    class="measurement bg-neutral-100 p-6 flex flex-col justify-between min-h-75"
    :class="computedClass">
    <div class="measurement__header mb-8">
      <h2 class="text-3xl font-sans font-bold">{{ title }}</h2>
      <span class="text-xl font-sans" v-if="subTitle">{{ subTitle }}</span>
    </div>
    <div class="measurement__body">
      <div
        v-if="body"
        class="apply-content-styles text-xl text-right font-sans"
        v-html="body"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
